import React from 'react';
import { CtaBlock } from '../../components/CtaBlock';
import { Footer } from '../../components/Footer';
import { Header } from '../../components/Header';
import { HeaderPage } from '../../components/HeaderPage';
import './style.css';

export const DatenschutzerklaerungDesktop = ({
    shareFeedbackEmailAddress: shareFeedbackEmailAddress,
}) => {
    return (
        <div className="homepage-desktop datenschutz-desktop">
            <Header
                className="design-component-instance-node-3"
                style="desktop"
                shareFeedbackEmailAddress={shareFeedbackEmailAddress}
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />
            <HeaderPage
                align="left"
                background="default"
                breadcrumbLinkText="Impressum"
                breakpoint="desktop"
                className="header-page-2"
                text=""
                title="Datenschutzerklärung "
            />
            <div className="content-wrapper"></div>
            <div className="content-wrapper">
                <div className="content-5" style={{ marginTop: '-80px' }}>
                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">
                                1&nbsp;&nbsp;&nbsp;&nbsp;Datenschutz auf einen
                                Blick
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Allgemeine Hinweise{' '}
                            </p>
                            <p className="text-wrapper-12">
                                Die folgenden Hinweise geben einen einfachen
                                Überblick darüber, was mit Ihren
                                personenbezogenen Daten passiert, wenn Sie diese
                                Website besuchen. Personenbezogene Daten sind
                                alle Daten, mit denen Sie persönlich
                                identifiziert werden können. Ausführliche
                                Informationen zum Thema Datenschutz entnehmen
                                Sie unserer unter diesem Text aufgeführten
                                Datenschutzerklärung.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Datenerfassung auf dieser Website
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '1.5em' }}
                            >
                                Wer ist verantwortlich für die Datenerfassung
                                auf dieser Website?
                            </p>
                            <p className="text-wrapper-12">
                                Die Datenverarbeitung auf dieser Website erfolgt
                                durch den Websitebetreiber. Dessen Kontaktdaten
                                können Sie dem Abschnitt „Hinweis zur
                                Verantwortlichen Stelle“ in dieser
                                Datenschutzerklärung entnehmen.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '1.5em' }}
                            >
                                Wie erfassen wir Ihre Daten?
                            </p>
                            <p className="text-wrapper-12">
                                Ihre Daten werden zum einen dadurch erhoben,
                                dass Sie uns diese mitteilen. Hierbei kann es
                                sich z. B. um Daten handeln, die Sie in ein
                                Kontaktformular eingeben.
                            </p>

                            <p className="text-wrapper-12">
                                Andere Daten werden automatisch oder nach Ihrer
                                Einwilligung beim Besuch der Website durch
                                unsere IT- Systeme erfasst. Das sind vor allem
                                technische Daten (z. B. Internetbrowser,
                                Betriebssystem oder Uhrzeit des Seitenaufrufs).
                                Die Erfassung dieser Daten erfolgt automatisch,
                                sobald Sie diese Website betreten.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '1.5em' }}
                            >
                                Wofür nutzen wir Ihre Daten?
                            </p>
                            <p className="text-wrapper-12">
                                Ein Teil der Daten wird erhoben, um eine
                                fehlerfreie Bereitstellung der Website zu
                                gewährleisten. Andere Daten können zur Analyse
                                Ihres Nutzerverhaltens verwendet werden.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '1.5em' }}
                            >
                                Welche Rechte haben Sie bezüglich Ihrer Daten?
                            </p>
                            <p className="text-wrapper-12">
                                Sie haben jederzeit das Recht, unentgeltlich
                                Auskunft über Herkunft, Empfänger und Zweck
                                Ihrer gespeicherten personenbezogenen Daten zu
                                erhalten. Sie haben außerdem ein Recht, die
                                Berichtigung oder Löschung dieser Daten zu
                                verlangen. Wenn Sie eine Einwilligung zur
                                Datenverarbeitung erteilt haben, können Sie
                                diese Einwilligung jederzeit für die Zukunft
                                widerrufen. Außerdem haben Sie das Recht, unter
                                bestimmten Umständen die Einschränkung der
                                Verarbeitung Ihrer personenbezogenen Daten zu
                                verlangen. Des Weiteren steht Ihnen ein
                                Beschwerderecht bei der zuständigen
                                Aufsichtsbehörde zu.Hierzu sowie zu weiteren
                                Fragen zum Thema Datenschutz können Sie sich
                                jederzeit an uns wenden.
                            </p>
                        </div>
                    </div>

                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">
                                2&nbsp;&nbsp;&nbsp;&nbsp;Hosting
                            </p>

                            <p className="text-wrapper-12">
                                Wir hosten die Inhalte unserer Website bei
                                folgendem Anbieter:
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Externes Hosting
                            </p>
                            <p className="text-wrapper-12">
                                Diese Website wird extern gehostet. Die
                                personenbezogenen Daten, die auf dieser Website
                                erfasst werden, werden auf den Servern des
                                Hosters / der Hoster gespeichert. Hierbei kann
                                es sich v. a. um IP-Adressen, Kontaktanfragen,
                                Meta- und Kommunikationsdaten, Vertragsdaten,
                                Kontaktdaten, Namen, Websitezugriffe und
                                sonstige Daten, die über eine Website generiert
                                werden, handeln.
                            </p>
                            <p className="text-wrapper-12">
                                Das externe Hosting erfolgt zum Zwecke der
                                Vertragserfüllung gegenüber unseren potenziellen
                                und bestehenden Kunden (Art. 6 Abs. 1 lit. b
                                DSGVO) und im Interesse einer sicheren,
                                schnellen und effizienten Bereitstellung unseres
                                Online-Angebots durch einen professionellen
                                Anbieter (Art. 6 Abs. 1 lit. f DSGVO). Sofern
                                eine entsprechende Einwilligung abgefragt wurde,
                                erfolgt die Verarbeitung ausschließlich auf
                                Grundlage von Art. 6 Abs. 1 lit. a DSGVO und §
                                25 Abs. 1 TTDSG, soweit die Einwilligung die
                                Speicherung von Cookies oder den Zugriff auf
                                Informationen im Endgerät des Nutzers (z. B.
                                Device-Fingerprinting) im Sinne des TTDSG
                                umfasst. Die Einwilligung ist jederzeit
                                widerrufbar.
                            </p>
                            <p className="text-wrapper-12">
                                Unser(e) Hoster wird bzw. werden Ihre Daten nur
                                insoweit verarbeiten, wie dies zur Erfüllung
                                seiner Leistungspflichten erforderlich ist und
                                unsere Weisungen in Bezug auf diese Daten
                                befolgen.
                            </p>
                            <p className="text-wrapper-12">
                                Wir setzen folgende(n) Hoster ein:
                            </p>
                            <p className="text-wrapper-12">
                                Contabo GmbH
                                <br />
                                Aschauer Straße 32a
                                <br />
                                81549 München
                                <br />
                                Deutschland
                                <br />
                            </p>
                        </div>
                    </div>

                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">
                                3&nbsp;&nbsp;&nbsp;&nbsp;Allgemeine Hinweise und
                                Pflichtinformationen{' '}
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Datenschutz{' '}
                            </p>
                            <p className="text-wrapper-12">
                                Die Betreiber dieser Seiten nehmen den Schutz
                                Ihrer persönlichen Daten sehr ernst. Wir
                                behandeln Ihre personenbezogenen Daten
                                vertraulich und entsprechend den gesetzlichen
                                Datenschutzvorschriften sowie dieser
                                Datenschutzerklärung.
                            </p>
                            <p className="text-wrapper-12">
                                Wenn Sie diese Website benutzen, werden
                                verschiedene personenbezogene Daten erhoben.
                                Personenbezogene Daten sind Daten, mit denen Sie
                                persönlich identifiziert werden können. Die
                                vorliegende Datenschutzerklärung erläutert,
                                welche Daten wir erheben und wofür wir sie
                                nutzen. Sie erläutert auch, wie und zu welchem
                                Zweck das geschieht.
                            </p>
                            <p className="text-wrapper-12">
                                Wir weisen darauf hin, dass die Datenübertragung
                                im Internet (z. B. bei der Kommunikation per
                                E-Mail) Sicherheitslücken aufweisen kann. Ein
                                lückenloser Schutz der Daten vor dem Zugriff
                                durch Dritte ist nicht möglich.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Hinweis zur verantwortlichen Stelle
                            </p>
                            <p className="text-wrapper-12">
                                Die verantwortliche Stelle für die
                                Datenverarbeitung auf dieser Website ist:
                            </p>
                            <p className="text-wrapper-12">
                                Universität Tübingen
                                <br />
                                Tübingen Center for Digital Education
                                <br />
                                Prof. Dr. Andreas Lachner Wilhelmsstraße 31
                                72074 Tübingen
                                <br />
                                Telefon: +49 (0) 7071 29-77454
                                <br />
                                E-Mail: andreas.lachner@uni-tuebingen.de
                                <br />
                            </p>
                            <p className="text-wrapper-12">
                                Verantwortliche Stelle ist die natürliche oder
                                juristische Person, die allein oder gemeinsam
                                mit anderen über die Zwecke und Mittel der
                                Verarbeitung von personenbezogenen Daten (z. B.
                                Namen, E-Mail-Adressen o. Ä.) entscheidet.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Speicherdauer{' '}
                            </p>
                            <p className="text-wrapper-12">
                                Soweit innerhalb dieser Datenschutzerklärung
                                keine speziellere Speicherdauer genannt wurde,
                                verbleiben Ihre personenbezogenen Daten bei uns,
                                bis der Zweck für die Datenverarbeitung
                                entfällt. Wenn Sie ein berechtigtes
                                Löschersuchen geltend machen oder eine
                                Einwilligung zur Datenverarbeitung widerrufen,
                                werden Ihre Daten gelöscht, sofern wir keine
                                anderen rechtlich zulässigen Gründe für die
                                Speicherung Ihrer personenbezogenen Daten haben
                                (z. B. steuer- oder handelsrechtliche
                                Aufbewahrungsfristen); im letztgenannten Fall
                                erfolgt die Löschung nach Fortfall dieser
                                Gründe.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Allgemeine Hinweise zu den Rechtsgrundlagen der
                                Datenverarbeitung auf dieser Website
                            </p>
                            <p className="text-wrapper-12">
                                Sofern Sie in die Datenverarbeitung eingewilligt
                                haben, verarbeiten wir Ihre personenbezogenen
                                Daten auf Grundlage von Art. 6 Abs. 1 lit. a
                                DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern
                                besondere Datenkategorien nach Art. 9 Abs. 1
                                DSGVO verarbeitet werden. Im Falle einer
                                ausdrücklichen Einwilligung in die Übertragung
                                personenbezogener Daten in Drittstaaten erfolgt
                                die Datenverarbeitung außerdem auf Grundlage von
                                Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die
                                Speicherung von Cookies oder in den Zugriff auf
                                Informationen in Ihr Endgerät (z. B. via
                                Device-Fingerprinting) eingewilligt haben,
                                erfolgt die Datenverarbeitung zusätzlich auf
                                Grundlage von § 25 Abs. 1 TTDSG. Die
                                Einwilligung ist jederzeit widerrufbar. Sind
                                Ihre Daten zur Vertragserfüllung oder zur
                                Durchführung vorvertraglicher Maßnahmen
                                erforderlich, verarbeiten wir Ihre Daten auf
                                Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des
                                Weiteren verarbeiten wir Ihre Daten, sofern
                                diese zur Erfüllung einer rechtlichen
                                Verpflichtung erforderlich sind auf Grundlage
                                von Art. 6 Abs. 1 lit. c DSGVO. Die
                                Datenverarbeitung kann ferner auf Grundlage
                                unseres berechtigten Interesses nach Art. 6 Abs.
                                1 lit. f DSGVO erfolgen. Über die jeweils im
                                Einzelfall einschlägigen Rechtsgrundlagen wird
                                in den folgenden Absätzen dieser
                                Datenschutzerklärung informiert.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Hinweis zur Datenweitergabe in
                                datenschutzrechtlich nicht sichere Drittstaaten
                                sowie die Weitergabe an US-Unternehmen, die
                                nicht DPF-zertifiziert sind{' '}
                            </p>
                            <p className="text-wrapper-12">
                                Wir verwenden unter anderem Tools von
                                Unternehmen mit Sitz in datenschutzrechtlich
                                nicht sicheren Drittstaaten sowie US-Tools,
                                deren Anbieter nicht nach dem EU-US-Data Privacy
                                Framework (DPF) zertifiziert sind. Wenn diese
                                Tools aktiv sind, können Ihre personenbezogene
                                Daten in diese Staaten übertragen und dort
                                verarbeitet werden. Wir weisen darauf hin, dass
                                in datenschutzrechtlich unsicheren Drittstaaten
                                kein mit der EU vergleichbares Datenschutzniveau
                                garantiert werden kann.
                            </p>
                            <p className="text-wrapper-12">
                                Wir weisen darauf hin, dass die USA als sicherer
                                Drittstaat grundsätzlich ein mit der EU
                                vergleichbares Datenschutzniveau aufweisen. Eine
                                Datenübertragung in die USA ist danach zulässig,
                                wenn der Empfänger eine Zertifizierung unter dem
                                „EU-US Data Privacy Framework“ (DPF) besitzt
                                oder über geeignete zusätzliche Garantien
                                verfügt. Informationen zu Übermittlungen an
                                Drittstaaten einschließlich der Datenempfänger
                                finden Sie in dieser Datenschutzerklärung.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Empfänger von personenbezogenen Daten{' '}
                            </p>
                            <p className="text-wrapper-12">
                                Im Rahmen unserer Geschäftstätigkeit arbeiten
                                wir mit verschiedenen externen Stellen zusammen.
                                Dabei ist teilweise auch eine Übermittlung von
                                personenbezogenen Daten an diese externen
                                Stellen erforderlich. Wir geben personenbezogene
                                Daten nur dann an externe Stellen weiter, wenn
                                dies im Rahmen einer Vertragserfüllung
                                erforderlich ist, wenn wir gesetzlich hierzu
                                verpflichtet sind (z. B. Weitergabe von Daten an
                                Steuerbehörden), wenn wir ein berechtigtes
                                Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der
                                Weitergabe haben oder wenn eine sonstige
                                Rechtsgrundlage die Datenweitergabe erlaubt.
                                Beim Einsatz von Auftragsverarbeitern geben wir
                                personenbezogene Daten unserer Kunden nur auf
                                Grundlage eines gültigen Vertrags über
                                Auftragsverarbeitung weiter. Im Falle einer
                                gemeinsamen Verarbeitung wird ein Vertrag über
                                gemeinsame Verarbeitung geschlossen.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Widerruf Ihrer Einwilligung zur
                                Datenverarbeitung
                            </p>
                            <p className="text-wrapper-12">
                                Viele Datenverarbeitungsvorgänge sind nur mit
                                Ihrer ausdrücklichen Einwilligung möglich. Sie
                                können eine bereits erteilte Einwilligung
                                jederzeit widerrufen. Die Rechtmäßigkeit der bis
                                zum Widerruf erfolgten Datenverarbeitung bleibt
                                vom Widerruf unberührt.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Widerspruchsrecht gegen die Datenerhebung in
                                besonderen Fällen sowie gegen Direktwerbung
                                (Art. 21 DSGVO)
                            </p>
                            <p className="text-wrapper-12">
                                WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON
                                ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN
                                SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH
                                AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN
                                DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN
                                WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN
                                AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE
                                JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE
                                VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER
                                DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH
                                EINLEGEN, WERDEN WIR IHRE BETROFFENEN
                                PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN,
                                ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE
                                GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE
                                INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN
                                ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG,
                                AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN
                                (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
                            </p>
                            <p className="text-wrapper-12">
                                WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET,
                                UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS
                                RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE
                                VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER
                                DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN;
                                DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT
                                SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN
                                SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN
                                DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER
                                DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART.
                                21 ABS. 2 DSGVO).
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Beschwerderecht bei der zuständigen
                                Aufsichtsbehörde
                            </p>
                            <p className="text-wrapper-12">
                                Im Falle von Verstößen gegen die DSGVO steht den
                                Betroffenen ein Beschwerderecht bei einer
                                Aufsichtsbehörde, insbesondere in dem
                                Mitgliedstaat ihres gewöhnlichen Aufenthalts,
                                ihres Arbeitsplatzes oder des Orts des
                                mutmaßlichen Verstoßes zu. Das Beschwerderecht
                                besteht unbeschadet anderweitiger
                                verwaltungsrechtlicher oder gerichtlicher
                                Rechtsbehelfe.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Recht auf Datenübertragbarkeit
                            </p>
                            <p className="text-wrapper-12">
                                Sie haben das Recht, Daten, die wir auf
                                Grundlage Ihrer Einwilligung oder in Erfüllung
                                eines Vertrags automatisiert verarbeiten, an
                                sich oder an einen Dritten in einem gängigen,
                                maschinenlesbaren Format aushändigen zu lassen.
                                Sofern Sie die direkte Übertragung der Daten an
                                einen anderen Verantwortlichen verlangen,
                                erfolgt dies nur, soweit es technisch machbar
                                ist.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Auskunft, Berichtigung und Löschung
                            </p>
                            <p className="text-wrapper-12">
                                Sie haben im Rahmen der geltenden gesetzlichen
                                Bestimmungen jederzeit das Recht auf
                                unentgeltliche Auskunft über Ihre gespeicherten
                                personenbezogenen Daten, deren Herkunft und
                                Empfänger und den Zweck der Datenverarbeitung
                                und ggf. ein Recht auf Berichtigung oder
                                Löschung dieser Daten. Hierzu sowie zu weiteren
                                Fragen zum Thema personenbezogene Daten können
                                Sie sich jederzeit an uns wenden.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Recht auf Einschränkung der Verarbeitung
                            </p>
                            <p className="text-wrapper-12">
                                Sie haben das Recht, die Einschränkung der
                                Verarbeitung Ihrer personenbezogenen Daten zu
                                verlangen. Hierzu können Sie sich jederzeit an
                                uns wenden. Das Recht auf Einschränkung der
                                Verarbeitung besteht in folgenden Fällen:
                            </p>

                            <ul style={{ listStyle: 'circle' }}>
                                <li>
                                    Wenn Sie die Richtigkeit Ihrer bei uns
                                    gespeicherten personenbezogenen Daten
                                    bestreiten, benötigen wir in der Regel Zeit,
                                    um dies zu überprüfen. Für die Dauer der
                                    Prüfung haben Sie das Recht, die
                                    Einschränkung der Verarbeitung Ihrer
                                    personenbezogenen Daten zu verlangen.
                                </li>
                                <li>
                                    Wenn die Verarbeitung Ihrer
                                    personenbezogenen Daten unrechtmäßig
                                    geschah/geschieht, können Sie statt der
                                    Löschung die Einschränkung der
                                    Datenverarbeitung verlangen.
                                </li>
                                <li>
                                    Wenn wir Ihre personenbezogenen Daten nicht
                                    mehr benötigen, Sie sie jedoch zur Ausübung,
                                    Verteidigung oder Geltendmachung von
                                    Rechtsansprüchen benötigen, haben Sie das
                                    Recht, statt der Löschung die Einschränkung
                                    der Verarbeitung Ihrer personenbezogenen
                                    Daten zu verlangen.
                                </li>
                                <li>
                                    Wenn Sie einen Widerspruch nach Art. 21 Abs.
                                    1 DSGVO eingelegt haben, muss eine Abwägung
                                    zwischen Ihren und unseren Interessen
                                    vorgenommen werden. Solange noch nicht
                                    feststeht, wessen Interessen überwiegen,
                                    haben Sie das Recht, die Einschränkung der
                                    Verarbeitung Ihrer personenbezogenen Daten
                                    zu verlangen.
                                </li>
                            </ul>

                            <p className="text-wrapper-12">
                                Wenn Sie die Verarbeitung Ihrer
                                personenbezogenen Daten eingeschränkt haben,
                                dürfen diese Daten – von ihrer Speicherung
                                abgesehen – nur mit Ihrer Einwilligung oder zur
                                Geltendmachung, Ausübung oder Verteidigung von
                                Rechtsansprüchen oder zum Schutz der Rechte
                                einer anderen natürlichen oder juristischen
                                Person oder aus Gründen eines wichtigen
                                öffentlichen Interesses der Europäischen Union
                                oder eines Mitgliedstaats verarbeitet werden.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                SSL- bzw. TLS-Verschlüsselung
                            </p>
                            <p className="text-wrapper-12">
                                Diese Seite nutzt aus Sicherheitsgründen und zum
                                Schutz der Übertragung vertraulicher Inhalte,
                                wie zum Beispiel Bestellungen oder Anfragen, die
                                Sie an uns als Seitenbetreiber senden, eine SSL-
                                bzw. TLS- Verschlüsselung. Eine verschlüsselte
                                Verbindung erkennen Sie daran, dass die
                                Adresszeile des Browsers von „http://“ auf
                                „https://“ wechselt und an dem Schloss-Symbol in
                                Ihrer Browserzeile.
                            </p>

                            <p className="text-wrapper-12">
                                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert
                                ist, können die Daten, die Sie an uns
                                übermitteln, nicht von Dritten mitgelesen
                                werden.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Widerspruch gegen Werbe-E-Mails
                            </p>
                            <p className="text-wrapper-12">
                                Der Nutzung von im Rahmen der Impressumspflicht
                                veröffentlichten Kontaktdaten zur Übersendung
                                von nicht ausdrücklich angeforderter Werbung und
                                Informationsmaterialien wird hiermit
                                widersprochen. Die Betreiber der Seiten behalten
                                sich ausdrücklich rechtliche Schritte im Falle
                                der unverlangten Zusendung von
                                Werbeinformationen, etwa durch Spam-E-Mails,
                                vor.
                            </p>
                        </div>
                    </div>

                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">
                                4&nbsp;&nbsp;&nbsp;&nbsp;Datenerfassung auf
                                dieser Website
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Cookies
                            </p>
                            <p className="text-wrapper-12">
                                Unsere Internetseiten verwenden so genannte
                                „Cookies“. Cookies sind kleine Datenpakete und
                                richten auf Ihrem Endgerät keinen Schaden an.
                                Sie werden entweder vorübergehend für die Dauer
                                einer Sitzung (Session-Cookies) oder dauerhaft
                                (permanente Cookies) auf Ihrem Endgerät
                                gespeichert. Session-Cookies werden nach Ende
                                Ihres Besuchs automatisch gelöscht. Permanente
                                Cookies bleiben auf Ihrem Endgerät gespeichert,
                                bis Sie diese selbst löschen oder eine
                                automatische Löschung durch Ihren Webbrowser
                                erfolgt.
                            </p>

                            <p className="text-wrapper-12">
                                Cookies können von uns (First-Party-Cookies)
                                oder von Drittunternehmen stammen (sog.
                                Third-Party- Cookies). Third-Party-Cookies
                                ermöglichen die Einbindung bestimmter
                                Dienstleistungen von Drittunternehmen innerhalb
                                von Webseiten (z. B. Cookies zur Abwicklung von
                                Zahlungsdienstleistungen).
                            </p>

                            <p className="text-wrapper-12">
                                Cookies haben verschiedene Funktionen.
                                Zahlreiche Cookies sind technisch notwendig, da
                                bestimmte Webseitenfunktionen ohne diese nicht
                                funktionieren würden (z. B. die
                                Warenkorbfunktion oder die Anzeige von Videos).
                                Andere Cookies können zur Auswertung des
                                Nutzerverhaltens oder zu Werbezwecken verwendet
                                werden.
                            </p>

                            <p className="text-wrapper-12">
                                Cookies, die zur Durchführung des elektronischen
                                Kommunikationsvorgangs, zur Bereitstellung
                                bestimmter, von Ihnen erwünschter Funktionen (z.
                                B. für die Warenkorbfunktion) oder zur
                                Optimierung der Website (z. B. Cookies zur
                                Messung des Webpublikums) erforderlich sind
                                (notwendige Cookies), werden auf Grundlage von
                                Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern
                                keine andere Rechtsgrundlage angegeben wird. Der
                                Websitebetreiber hat ein berechtigtes Interesse
                                an der Speicherung von notwendigen Cookies zur
                                technisch fehlerfreien und optimierten
                                Bereitstellung seiner Dienste. Sofern eine
                                Einwilligung zur Speicherung von Cookies und
                                vergleichbaren Wiedererkennungstechnologien
                                abgefragt wurde, erfolgt die Verarbeitung
                                ausschließlich auf Grundlage dieser Einwilligung
                                (Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
                                TTDSG); die Einwilligung ist jederzeit
                                widerrufbar.
                            </p>

                            <p className="text-wrapper-12">
                                Sie können Ihren Browser so einstellen, dass Sie
                                über das Setzen von Cookies informiert werden
                                und Cookies nur im Einzelfall erlauben, die
                                Annahme von Cookies für bestimmte Fälle oder
                                generell ausschließen sowie das automatische
                                Löschen der Cookies beim Schließen des Browsers
                                aktivieren. Bei der Deaktivierung von Cookies
                                kann die Funktionalität dieser Website
                                eingeschränkt sein.
                            </p>

                            <p className="text-wrapper-12">
                                Welche Cookies und Dienste auf dieser Website
                                eingesetzt werden, können Sie dieser
                                Datenschutzerklärung entnehmen.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Server-Log-Dateien{' '}
                            </p>
                            <p className="text-wrapper-12">
                                Der Provider der Seiten erhebt und speichert
                                automatisch Informationen in so genannten
                                Server-Log- Dateien, die Ihr Browser automatisch
                                an uns übermittelt. Dies sind:
                            </p>
                            <p className="text-wrapper-12">
                                Browsertyp und Browserversion
                                <br />
                                verwendetes Betriebssystem
                                <br />
                                Referrer URL
                                <br />
                                Hostname des zugreifenden Rechners
                                <br />
                                Uhrzeit der Serveranfrage
                                <br />
                                IP-Adresse
                                <br />
                            </p>

                            <p className="text-wrapper-12">
                                Eine Zusammenführung dieser Daten mit anderen
                                Datenquellen wird nicht vorgenommen.
                            </p>

                            <p className="text-wrapper-12">
                                Die Erfassung dieser Daten erfolgt auf Grundlage
                                von Art. 6 Abs. 1 lit. f DSGVO. Der
                                Websitebetreiber hat ein berechtigtes Interesse
                                an der technisch fehlerfreien Darstellung und
                                der Optimierung seiner Website – hierzu müssen
                                die Server-Log-Files erfasst werden.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Kontaktformular{' '}
                            </p>
                            <p className="text-wrapper-12">
                                Wenn Sie uns per Kontaktformular Anfragen
                                zukommen lassen, werden Ihre Angaben aus dem
                                Anfrageformular inklusive der von Ihnen dort
                                angegebenen Kontaktdaten zwecks Bearbeitung der
                                Anfrage und für den Fall von Anschlussfragen bei
                                uns gespeichert. Diese Daten geben wir nicht
                                ohne Ihre Einwilligung weiter.
                            </p>
                            <p className="text-wrapper-12">
                                Die Verarbeitung dieser Daten erfolgt auf
                                Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern
                                Ihre Anfrage mit der Erfüllung eines Vertrags
                                zusammenhängt oder zur Durchführung
                                vorvertraglicher Maßnahmen erforderlich ist. In
                                allen übrigen Fällen beruht die Verarbeitung auf
                                unserem berechtigten Interesse an der effektiven
                                Bearbeitung der an uns gerichteten Anfragen
                                (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
                                Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern
                                diese abgefragt wurde; die Einwilligung ist
                                jederzeit widerrufbar.
                            </p>
                            <p className="text-wrapper-12">
                                Die von Ihnen im Kontaktformular eingegebenen
                                Daten verbleiben bei uns, bis Sie uns zur
                                Löschung auffordern, Ihre Einwilligung zur
                                Speicherung widerrufen oder der Zweck für die
                                Datenspeicherung entfällt (z. B. nach
                                abgeschlossener Bearbeitung Ihrer Anfrage).
                                Zwingende gesetzliche Bestimmungen –
                                insbesondere Aufbewahrungsfristen – bleiben
                                unberührt.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Anfrage per E-Mail, Telefon oder Telefax
                            </p>
                            <p className="text-wrapper-12">
                                Wenn Sie uns per E-Mail, Telefon oder Telefax
                                kontaktieren, wird Ihre Anfrage inklusive aller
                                daraus hervorgehenden personenbezogenen Daten
                                (Name, Anfrage) zum Zwecke der Bearbeitung Ihres
                                Anliegens bei uns gespeichert und verarbeitet.
                                Diese Daten geben wir nicht ohne Ihre
                                Einwilligung weiter.
                            </p>
                            <p className="text-wrapper-12">
                                Die Verarbeitung dieser Daten erfolgt auf
                                Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern
                                Ihre Anfrage mit der Erfüllung eines Vertrags
                                zusammenhängt oder zur Durchführung
                                vorvertraglicher Maßnahmen erforderlich ist. In
                                allen übrigen Fällen beruht die Verarbeitung auf
                                unserem berechtigten Interesse an der effektiven
                                Bearbeitung der an uns gerichteten Anfragen
                                (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
                                Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern
                                diese abgefragt wurde; die Einwilligung ist
                                jederzeit widerrufbar.
                            </p>
                            <p className="text-wrapper-12">
                                Die von Ihnen an uns per Kontaktanfragen
                                übersandten Daten verbleiben bei uns, bis Sie
                                uns zur Löschung auffordern, Ihre Einwilligung
                                zur Speicherung widerrufen oder der Zweck für
                                die Datenspeicherung entfällt (z. B. nach
                                abgeschlossener Bearbeitung Ihres Anliegens).
                                Zwingende gesetzliche Bestimmungen –
                                insbesondere gesetzliche Aufbewahrungsfristen –
                                bleiben unberührt.
                            </p>
                        </div>
                    </div>

                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">
                                5&nbsp;&nbsp;&nbsp;&nbsp;Soziale Medien
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Facebook
                            </p>
                            <p className="text-wrapper-12">
                                Auf dieser Website sind Elemente des sozialen
                                Netzwerks Facebook integriert. Anbieter dieses
                                Dienstes ist die Meta Platforms Ireland Limited,
                                4 Grand Canal Square, Dublin 2, Irland. Die
                                erfassten Daten werden nach Aussage von Facebook
                                jedoch auch in die USA und in andere Drittländer
                                übertragen.
                            </p>
                            <p className="text-wrapper-12">
                                Eine Übersicht über die Facebook
                                Social-Media-Elemente finden Sie hier:{' '}
                                <a href="https://developers.facebook.com/docs/plugins/?locale=de_DE">
                                    https://developers.facebook.com/docs/plugins/?locale=de_DE
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Wenn das Social-Media-Element aktiv ist, wird
                                eine direkte Verbindung zwischen Ihrem Endgerät
                                und dem Facebook-Server hergestellt. Facebook
                                erhält dadurch die Information, dass Sie mit
                                Ihrer IP-Adresse diese Website besucht haben.
                                Wenn Sie den Facebook „Like-Button“ anklicken,
                                während Sie in Ihrem Facebook- Account
                                eingeloggt sind, können Sie die Inhalte dieser
                                Website auf Ihrem Facebook-Profil verlinken.
                                Dadurch kann Facebook den Besuch dieser Website
                                Ihrem Benutzerkonto zuordnen. Wir weisen darauf
                                hin, dass wir als Anbieter der Seiten keine
                                Kenntnis vom Inhalt der übermittelten Daten
                                sowie deren Nutzung durch Facebook erhalten.
                                Weitere Informationen hierzu finden Sie in der
                                Datenschutzerklärung von Facebook unter:{' '}
                                <a href="https://de-de.facebook.com/privacy/explanation">
                                    https://de-de.facebook.com/privacy/explanation
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Soweit eine Einwilligung (Consent) eingeholt
                                wurde, erfolgt der Einsatz des o. g. Dienstes
                                auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und
                                § 25 TTDSG. Die Einwilligung ist jederzeit
                                widerrufbar. Soweit keine Einwilligung eingeholt
                                wurde, erfolgt die Verwendung des Dienstes auf
                                Grundlage unseres berechtigten Interesses an
                                einer möglichst umfassenden Sichtbarkeit in den
                                Sozialen Medien.
                            </p>
                            <p className="text-wrapper-12">
                                Soweit mit Hilfe des hier beschriebenen Tools
                                personenbezogene Daten auf unserer Website
                                erfasst und an Facebook weitergeleitet werden,
                                sind wir und die Meta Platforms Ireland Limited,
                                4 Grand Canal Square, Grand Canal Harbour,
                                Dublin 2, Irland gemeinsam für diese
                                Datenverarbeitung verantwortlich (Art. 26
                                DSGVO). Die gemeinsame Verantwortlichkeit
                                beschränkt sich dabei ausschließlich auf die
                                Erfassung der Daten und deren Weitergabe an
                                Facebook. Die nach der Weiterleitung erfolgende
                                Verarbeitung durch Facebook ist nicht Teil der
                                gemeinsamen Verantwortung. Die uns gemeinsam
                                obliegenden Verpflichtungen wurden in einer
                                Vereinbarung über gemeinsame Verarbeitung
                                festgehalten. Den Wortlaut der Vereinbarung
                                finden Sie unter:{' '}
                                <a href="https://www.facebook.com/legal/controller_addendum">
                                    https://www.facebook.com/legal/controller_addendum
                                </a>
                                . Laut dieser Vereinbarung sind wir für die
                                Erteilung der Datenschutzinformationen beim
                                Einsatz des Facebook-Tools und für die
                                datenschutzrechtlich sichere Implementierung des
                                Tools auf unserer Website verantwortlich. Für
                                die Datensicherheit der Facebook- Produkte ist
                                Facebook verantwortlich. Betroffenenrechte (z.
                                B. Auskunftsersuchen) hinsichtlich der bei
                                Facebook verarbeiteten Daten können Sie direkt
                                bei Facebook geltend machen. Wenn Sie die
                                Betroffenenrechte bei uns geltend machen, sind
                                wir verpflichtet, diese an Facebook
                                weiterzuleiten.
                            </p>
                            <p className="text-wrapper-12">
                                Die Datenübertragung in die USA wird auf die
                                Standardvertragsklauseln der EU-Kommission
                                gestützt. Details finden Sie hier:{' '}
                                <a href="https://www.facebook.com/legal/EU_data_transfer_addendum">
                                    https://www.facebook.com/legal/EU_data_transfer_addendum
                                </a>
                                ,{' '}
                                <a href="https://de-de.facebook.com/help/566994660333381">
                                    https://de-de.facebook.com/help/566994660333381
                                </a>{' '}
                                und{' '}
                                <a href="https://www.facebook.com/policy.php">
                                    https://www.facebook.com/policy.php
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Das Unternehmen verfügt über eine Zertifizierung
                                nach dem „EU-US Data Privacy Framework“ (DPF).
                                Der DPF ist ein Übereinkommen zwischen der
                                Europäischen Union und den USA, der die
                                Einhaltung europäischer Datenschutzstandards bei
                                Datenverarbeitungen in den USA gewährleisten
                                soll. Jedes nach dem DPF zertifizierte
                                Unternehmen verpflichtet sich, diese
                                Datenschutzstandards einzuhalten. Weitere
                                Informationen hierzu erhalten Sie vom Anbieter
                                unter folgendem Link:{' '}
                                <a href="https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active">
                                    https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active
                                </a>
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                X (ehemals Twitter){' '}
                            </p>
                            <p className="text-wrapper-12">
                                Auf dieser Website sind Funktionen des Dienstes
                                X (ehemals Twitter) eingebunden. Diese
                                Funktionen werden angeboten durch den
                                Mutterkonzern X Corp., 1355 Market Street, Suite
                                900, San Francisco, CA 94103, USA. Für die
                                Datenverarbeitung von außerhalb der USA lebenden
                                Personen ist die Niederlassung Twitter
                                International Unlimited Company, One Cumberland
                                Place, Fenian Street, Dublin 2, D02 AX07,
                                Irland, verantwortlich.
                            </p>
                            <p className="text-wrapper-12">
                                Wenn das Social-Media-Element aktiv ist, wird
                                eine direkte Verbindung zwischen Ihrem Endgerät
                                und dem X- Server hergestellt. X (ehemals
                                Twitter) erhält dadurch Informationen über den
                                Besuch dieser Website durch Sie. Durch das
                                Benutzen von X (ehemals Twitter) und der
                                Funktion „Re-Tweet“ bzw. „Repost“ werden die von
                                Ihnen besuchten Websites mit Ihrem X (ehemals
                                Twitter)-Account verknüpft und anderen Nutzern
                                bekannt gegeben. Wir weisen darauf hin, dass wir
                                als Anbieter der Seiten keine Kenntnis vom
                                Inhalt der
                            </p>
                            <p className="text-wrapper-12">
                                übermittelten Daten sowie deren Nutzung durch X
                                (ehemals Twitter) erhalten. Weitere
                                Informationen hierzu finden Sie in der
                                Datenschutzerklärung von X (ehemals Twitter)
                                unter:{' '}
                                <a href="https://twitter.com/de/privacy">
                                    https://twitter.com/de/privacy
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Soweit eine Einwilligung (Consent) eingeholt
                                wurde, erfolgt der Einsatz des o. g. Dienstes
                                auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und
                                § 25 TTDSG. Die Einwilligung ist jederzeit
                                widerrufbar. Soweit keine Einwilligung eingeholt
                                wurde, erfolgt die Verwendung des Dienstes auf
                                Grundlage unseres berechtigten Interesses an
                                einer möglichst umfassenden Sichtbarkeit in den
                                Sozialen Medien.
                            </p>
                            <p className="text-wrapper-12">
                                Die Datenübertragung in die USA wird auf die
                                Standardvertragsklauseln der EU-Kommission
                                gestützt. Details finden Sie hier:{' '}
                                <a href="https://gdpr.twitter.com/en/controller-to-controller-transfers.html">
                                    https://gdpr.twitter.com/en/controller-to-controller-transfers.html
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Ihre Datenschutzeinstellungen bei X (ehemals
                                Twitter) können Sie in den Konto-Einstellungen
                                unter{' '}
                                <a href="https://twitter.com/account/settings">
                                    https://twitter.com/account/settings
                                </a>{' '}
                                ändern.
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Instagram
                            </p>
                            <p className="text-wrapper-12">
                                Auf dieser Website sind Funktionen des Dienstes
                                Instagram eingebunden. Diese Funktionen werden
                                angeboten durch die Meta Platforms Ireland
                                Limited, 4 Grand Canal Square, Grand Canal
                                Harbour, Dublin 2, Irland.
                            </p>
                            <p className="text-wrapper-12">
                                Wenn das Social-Media-Element aktiv ist, wird
                                eine direkte Verbindung zwischen Ihrem Endgerät
                                und dem Instagram-Server hergestellt. Instagram
                                erhält dadurch Informationen über den Besuch
                                dieser Website durch Sie.
                            </p>
                            <p className="text-wrapper-12">
                                Wenn Sie in Ihrem Instagram-Account eingeloggt
                                sind, können Sie durch Anklicken des
                                Instagram-Buttons die Inhalte dieser Website mit
                                Ihrem Instagram-Profil verlinken. Dadurch kann
                                Instagram den Besuch dieser Website Ihrem
                                Benutzerkonto zuordnen. Wir weisen darauf hin,
                                dass wir als Anbieter der Seiten keine Kenntnis
                                vom Inhalt der übermittelten Daten sowie deren
                                Nutzung durch Instagram erhalten.
                            </p>
                            <p className="text-wrapper-12">
                                Soweit eine Einwilligung (Consent) eingeholt
                                wurde, erfolgt der Einsatz des o. g. Dienstes
                                auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und
                                § 25 TTDSG. Die Einwilligung ist jederzeit
                                widerrufbar. Soweit keine Einwilligung eingeholt
                                wurde, erfolgt die Verwendung des Dienstes auf
                                Grundlage unseres berechtigten Interesses an
                                einer möglichst umfassenden Sichtbarkeit in den
                                Sozialen Medien.
                            </p>
                            <p className="text-wrapper-12">
                                Soweit mit Hilfe des hier beschriebenen Tools
                                personenbezogene Daten auf unserer Website
                                erfasst und an Facebook bzw. Instagram
                                weitergeleitet werden, sind wir und die Meta
                                Platforms Ireland Limited, 4 Grand Canal Square,
                                Grand Canal Harbour, Dublin 2, Irland gemeinsam
                                für diese Datenverarbeitung verantwortlich (Art.
                                26 DSGVO). Die gemeinsame Verantwortlichkeit
                                beschränkt sich dabei ausschließlich auf die
                                Erfassung der Daten und deren Weitergabe an
                                Facebook bzw. Instagram. Die nach der
                                Weiterleitung erfolgende Verarbeitung durch
                                Facebook bzw. Instagram ist nicht Teil der
                                gemeinsamen Verantwortung. Die uns gemeinsam
                                obliegenden Verpflichtungen wurden in einer
                                Vereinbarung über gemeinsame Verarbeitung
                                festgehalten. Den Wortlaut der Vereinbarung
                                finden Sie unter:{' '}
                                <a href="https://www.facebook.com/legal/controller_addendum">
                                    https://www.facebook.com/legal/controller_addendum
                                </a>
                                . Laut dieser Vereinbarung sind wir für die
                                Erteilung der Datenschutzinformationen beim
                                Einsatz des Facebook- bzw. Instagram-Tools und
                                für die datenschutzrechtlich sichere
                                Implementierung des Tools auf unserer Website
                                verantwortlich. Für die Datensicherheit der
                                Facebook bzw. Instagram-Produkte ist Facebook
                                verantwortlich. Betroffenenrechte
                            </p>
                            <p className="text-wrapper-12">
                                (z. B. Auskunftsersuchen) hinsichtlich der bei
                                Facebook bzw. Instagram verarbeiteten Daten
                                können Sie direkt bei Facebook geltend machen.
                                Wenn Sie die Betroffenenrechte bei uns geltend
                                machen, sind wir verpflichtet, diese an Facebook
                                weiterzuleiten.
                            </p>
                            <p className="text-wrapper-12">
                                Die Datenübertragung in die USA wird auf die
                                Standardvertragsklauseln der EU-Kommission
                                gestützt. Details finden Sie hier:
                                https://www.facebook.com/legal/EU_data_transfer_addendum,{' '}
                                <a href="https://privacycenter.instagram.com/policy/">
                                    https://privacycenter.instagram.com/policy/
                                </a>{' '}
                                und{' '}
                                <a href="https://de-de.facebook.com/help/566994660333381">
                                    https://de-de.facebook.com/help/566994660333381
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Weitere Informationen hierzu finden Sie in der
                                Datenschutzerklärung von Instagram:{' '}
                                <a href="https://privacycenter.instagram.com/policy/">
                                    https://privacycenter.instagram.com/policy/
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Das Unternehmen verfügt über eine Zertifizierung
                                nach dem „EU-US Data Privacy Framework“ (DPF).
                                Der DPF ist ein Übereinkommen zwischen der
                                Europäischen Union und den USA, der die
                                Einhaltung europäischer Datenschutzstandards bei
                                Datenverarbeitungen in den USA gewährleisten
                                soll. Jedes nach dem DPF zertifizierte
                                Unternehmen verpflichtet sich, diese
                                Datenschutzstandards einzuhalten. Weitere
                                Informationen hierzu erhalten Sie vom Anbieter
                                unter folgendem Link:{' '}
                                <a href="https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active">
                                    https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000GnywAAC&status=Active
                                </a>
                            </p>
                        </div>
                    </div>

                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-11">
                                6&nbsp;&nbsp;&nbsp;&nbsp;Plugins und Tools{' '}
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                YouTube mit erweitertem Datenschutz{' '}
                            </p>
                            <p className="text-wrapper-12">
                                Diese Website bindet Videos der Website YouTube
                                ein. Betreiber der Seiten ist die Google Ireland
                                Limited („Google“), Gordon House, Barrow Street,
                                Dublin 4, Irland.
                            </p>
                            <p className="text-wrapper-12">
                                Wir nutzen YouTube im erweiterten
                                Datenschutzmodus. Dieser Modus bewirkt laut
                                YouTube, dass YouTube keine Informationen über
                                die Besucher auf dieser Website speichert, bevor
                                diese sich das Video ansehen. Die Weitergabe von
                                Daten an YouTube-Partner wird durch den
                                erweiterten Datenschutzmodus hingegen nicht
                                zwingend ausgeschlossen. So stellt YouTube –
                                unabhängig davon, ob Sie sich ein Video ansehen
                                – eine Verbindung zum Google Marketing Netzwerk
                                her.
                            </p>
                            <p className="text-wrapper-12">
                                Sobald Sie ein YouTube-Video auf dieser Website
                                starten, wird eine Verbindung zu den Servern von
                                YouTube hergestellt. Dabei wird dem
                                YouTube-Server mitgeteilt, welche unserer Seiten
                                Sie besucht haben. Wenn Sie in Ihrem
                                YouTube-Account eingeloggt sind, ermöglichen Sie
                                YouTube, Ihr Surfverhalten direkt Ihrem
                                persönlichen Profil zuzuordnen. Dies können Sie
                                verhindern, indem Sie sich aus Ihrem YouTube-
                                Account ausloggen.
                            </p>
                            <p className="text-wrapper-12">
                                Des Weiteren kann YouTube nach Starten eines
                                Videos verschiedene Cookies auf Ihrem Endgerät
                                speichern oder vergleichbare
                                Wiedererkennungstechnologien (z. B.
                                Device-Fingerprinting) einsetzen. Auf diese
                                Weise kann YouTube Informationen über Besucher
                                dieser Website erhalten. Diese Informationen
                                werden u. a. verwendet, um Videostatistiken zu
                                erfassen, die Anwenderfreundlichkeit zu
                                verbessern und Betrugsversuchen vorzubeugen.
                            </p>
                            <p className="text-wrapper-12">
                                Gegebenenfalls können nach dem Start eines
                                YouTube-Videos weitere
                                Datenverarbeitungsvorgänge ausgelöst werden, auf
                                die wir keinen Einfluss haben.
                            </p>
                            <p className="text-wrapper-12">
                                Die Nutzung von YouTube erfolgt im Interesse
                                einer ansprechenden Darstellung unserer
                                Online-Angebote. Dies stellt ein berechtigtes
                                Interesse im Sinne von Art. 6 Abs. 1 lit. f
                                DSGVO dar. Sofern eine entsprechende
                                Einwilligung abgefragt wurde, erfolgt die
                                Verarbeitung ausschließlich auf Grundlage von
                                Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
                                TTDSG, soweit die Einwilligung die Speicherung
                                von Cookies oder den Zugriff auf Informationen
                                im Endgerät des Nutzers (z. B.
                                Device-Fingerprinting) im Sinne des TTDSG
                                umfasst. Die Einwilligung ist jederzeit
                                widerrufbar.
                            </p>
                            <p className="text-wrapper-12">
                                Weitere Informationen über Datenschutz bei
                                YouTube finden Sie in deren Datenschutzerklärung
                                unter:{' '}
                                <a href="https://policies.google.com/privacy?hl=de">
                                    https://policies.google.com/privacy?hl=de
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Das Unternehmen verfügt über eine Zertifizierung
                                nach dem „EU-US Data Privacy Framework“ (DPF).
                                Der DPF ist ein Übereinkommen zwischen der
                                Europäischen Union und den USA, der die
                                Einhaltung europäischer Datenschutzstandards bei
                                Datenverarbeitungen in den USA gewährleisten
                                soll. Jedes nach dem DPF zertifizierte
                                Unternehmen verpflichtet sich, diese
                                Datenschutzstandards einzuhalten. Weitere
                                Informationen hierzu erhalten Sie vom Anbieter
                                unter folgendem Link:{' '}
                                <a href="https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&status=Active">
                                    https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&status=Active
                                </a>
                            </p>

                            <p
                                className="text-wrapper-11"
                                style={{ fontSize: '2em' }}
                            >
                                Font Awesome (lokales Hosting){' '}
                            </p>
                            <p className="text-wrapper-12">
                                Diese Seite nutzt zur einheitlichen Darstellung
                                von Schriftarten Font Awesome. Font Awesome ist
                                lokal installiert. Eine Verbindung zu Servern
                                von Fonticons, Inc. findet dabei nicht statt.
                            </p>
                            <p className="text-wrapper-12">
                                Weitere Informationen zu Font Awesome finden Sie
                                in der Datenschutzerklärung für Font Awesome
                                unter:{' '}
                                <a href="https://fontawesome.com/privacy">
                                    https://fontawesome.com/privacy
                                </a>
                                .
                            </p>
                            <p className="text-wrapper-12">
                                Quelle:{' '}
                                <a href="https://www.e-recht24.de">
                                    https://www.e-recht24.de
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer
                className="design-component-instance-node-3"
                property1="desktop"
            />
        </div>
    );
};
